export default {"src":"/_next/static/media/check.fe9ff64a.svg","height":11,"width":10};